import { tryCatch } from '@thalesrc/js-utils';

import http from './http';
import { ROLE_URL, GROUP_URL, PERMISSION_URL } from '../utils/url';

// Role Management
async function getPermissions() {
  const [error, result] = await tryCatch(http.get(PERMISSION_URL));

  if (error) throw error;

  return result.data.data;
}

async function searchRoles(payload) {
  const [error, result] = await tryCatch(http.post(`${ROLE_URL}/search`, payload));

  if (error) throw error;

  return result.data.data;
}

async function getRoles() {
  const [error, result] = await tryCatch(http.get(ROLE_URL));

  if (error) throw error;

  return result.data.data;
}

async function getRoleDetail(roleId) {
  const [error, result] = await tryCatch(http.get(`${ROLE_URL}/${roleId}`));

  if (error) throw error;

  return result.data.data;
}

async function createRole(payload) {
  const [error, result] = await tryCatch(http.post(`${ROLE_URL}/create`, payload));

  if (error) throw error;

  return result.data.data;
}

async function updateRole(payload) {
  const [error, result] = await tryCatch(http.put(`${ROLE_URL}/update`, payload));

  if (error) throw error;

  return result.data.data;
}

async function deleteRole(roleId) {
  const [error, result] = await tryCatch(http.delete(`${ROLE_URL}/delete/${roleId}`));

  if (error) throw error;

  return result.data.data;
}

// User Role Management
async function getUserRoles() {
  const [error, result] = await tryCatch(http.get(`${ROLE_URL}/user-roles`));

  if (error) throw error;

  return result.data.data;
}

async function getUserRoleList(userId) {
  const [error, result] = await tryCatch(http.get(`${ROLE_URL}/user-role-list?userId=${userId}`));

  if (error) throw error;

  return result.data.data;
}

async function updateUserRoles(payload) {
  const [error, result] = await tryCatch(http.post(`${ROLE_URL}/user-role-edit`, payload));

  if (error) throw error;

  return result.data.data;
}

// Group Role Management
async function getGroups() {
  const [error, result] = await tryCatch(http.get(GROUP_URL));

  if (error) throw error;

  return result.data.data;
}

async function getGroupById(groupId) {
  const [error, result] = await tryCatch(http.get(`${GROUP_URL}/${groupId}`));

  if (error) throw error;

  return result.data.data;
}

async function createGroup(payload) {
  const [error, result] = await tryCatch(http.post(GROUP_URL, payload));

  if (error) throw error;

  return result.data.data;
}

async function updateGroup(payload) {
  const [error, result] = await tryCatch(http.put(GROUP_URL, payload));

  if (error) throw error;

  return result.data.data;
}

async function deleteGroup(groupId) {
  const [error, result] = await tryCatch(http.delete(`${GROUP_URL}/${groupId}`));

  if (error) throw error;

  return result.data.data;
}

async function updateGroupRoles(payload) {
  const [error, result] = await tryCatch(http.post(`${ROLE_URL}/group-role-edit`, payload));

  if (error) throw error;

  return result.data.data;
}

export const roleService = {
  getPermissions,
  searchRoles,
  getRoles,
  getRoleDetail,
  createRole,
  updateRole,
  deleteRole,
  getUserRoles,
  getUserRoleList,
  updateUserRoles,
  getGroups,
  getGroupById,
  createGroup,
  updateGroup,
  deleteGroup,
  updateGroupRoles
};
